import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Create a custom plugin to handle missing resources gracefully
const handleMissingResources = {
  type: 'backend',
  init: () => {},
  read: (language, namespace, callback) => {
    // If the resource is missing, return an empty object instead of an error
    callback(null, {});
  }
};

i18n
  // Load translations from /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Add our custom plugin as a fallback
  .use(handleMissingResources)
  // Initialize i18next
  .init({
    fallbackLng: 'en',
    debug: process.env['NODE_ENV'] === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Backend configuration
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Add custom request options to handle missing files gracefully
      requestOptions: {
        // This will prevent console errors for missing files
        cache: 'default',
        // Add a custom header to help with debugging
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        // Don't throw errors for missing files
        mode: 'cors'
      },
      // Add a custom handler for missing files
      addPath: '/locales/add/{{lng}}/{{ns}}',
    },

    // Default namespace
    defaultNS: 'common',
    ns: ['common'],
    // Only load namespaces when they're actually needed
    partialBundledLanguages: true,

    // React settings
    react: {
      useSuspense: true,
    },
    
    // Handle missing resources gracefully
    saveMissing: false,
    missingKeyHandler: (lng, ns, key) => {
      // Silently handle missing keys without console errors
      if (process.env['NODE_ENV'] !== 'development') {
        return;
      }
      // Only log in development mode
      console.debug(`Missing translation key: ${key} in namespace: ${ns} for language: ${lng}`);
    },
  });

export default i18n;
